import request from '@/libs/request';
import config from '@/config';
const baseUrl = config.api_base;

/**
 * 应用列表
 */
export const AppList = params => {
  return request('GET', `${baseUrl}/api/auth/sys/application/page`, params);
};

/**
 * 应用详情
 */
export const AppDetail = params => {
  return request('GET', `${baseUrl}/api/auth/sys/application/detail`, params);
};

/**
 * 新增应用
 */
export const AppAdd = data => {
  return request('POST', `${baseUrl}/api/auth/sys/application/add`, data);
};

/**
 * 编辑应用
 */
export const AppEdit = data => {
  return request('POST', `${baseUrl}/api/auth/sys/application/edit`, data);
};

/**
 * 删除应用
 */
export const AppDel = data => {
  return request('POST', `${baseUrl}/api/auth/sys/application/del`, data);
};

/**
 * 启用/禁用 应用
 */
export const AppSetStatus = data => {
  return request('POST', `${baseUrl}/api/auth/sys/application/toggle`, data);
};

/**
 * 获取应用密钥
 */
export const AppSecret = params => {
  return request('GET', `${baseUrl}/api/auth/sys/application/x`, params);
};
